import _ from 'lodash';

export const vincheckAdapter = (vincheck) => {
  const obj = {};
  _.set(obj, 'uid', _.get(vincheck, 'uid', null));
  _.set(obj, 'createdBy', _.get(vincheck, 'createdBy', null));
  _.set(obj, 'status', _.get(vincheck, 'status.id', null));
  return obj;
};
